import { render, staticRenderFns } from "./UserProfileCreate.vue?vue&type=template&id=3d133520&scoped=true&"
import script from "./UserProfileCreate.vue?vue&type=script&lang=js&"
export * from "./UserProfileCreate.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileCreate.vue?vue&type=style&index=0&id=3d133520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d133520",
  null
  
)

export default component.exports